import React, { useContext } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { colors } from '../context/Colors';
import Icon from 'react-native-vector-icons/Ionicons';
import { useColorScheme } from 'react-native-appearance';
import { useNavigation, useRoute } from '@react-navigation/native';
import InventoryObject from '../components/InventoryObject';
// import MiniAudioPlayer from '../components/MiniAudioPlayer';
import AppContext from '../context';

export default function InventoryDetail() {
  const { dict } = useContext(AppContext);
  const navigation = useNavigation();
  const theme = useColorScheme() === 'dark' ? 'dark' : 'light';
  const route = useRoute();
  const o = route.params?.i;
  // console.log(o);

  return (
    <View
      style={{
        padding: 10,
        borderRadius: 10
      }}
      onLayout={(e) => {
        // console.log('LAYOUT');
        // setGameMenuHeight(e.nativeEvent.layout.height);
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TouchableOpacity
          style={{ padding: 10, marginLeft: -10 }}
          onPress={() => navigation.goBack()}
        >
          <Icon name="chevron-back" color={colors[theme].text} size={22} />
        </TouchableOpacity>
        <Text
          style={{
            color: colors[theme].text,
            fontSize: 19,
            fontWeight: '600',
            flex: 1,
            textAlign: 'center'
          }}
        >
          {dict.artifact}
        </Text>
        <View style={{ width: 34 }} />
      </View>
      <View>
        <InventoryObject o={o} noText={true} />
        <View style={{ flex: 1, marginLeft: 0 }}>
          <View>
            <Text
              style={{
                color: colors[theme].text,
                fontSize: 18,
                marginBottom: 18,
                marginTop: 10,
                textAlign: 'center'
              }}
            >
              {o.objectName}
            </Text>
            <Text
              style={{
                color: colors[theme].text,
                textAlign: 'center'
              }}
            >
              {o.objectDescription}
            </Text>
          </View>

          {/*o.objectType === 'Object' && o.enablePhotoWithObject && (
            <View
              style={{
                marginTop: 20,
                flexDirection: 'row',
                justifyContent: 'space-evenly'
              }}
            >
              <TouchableOpacity
                style={{
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
                onPress={() => navigation.navigate('Camera', { artifact: o })}
              >
                <Icon
                  name="camera-reverse-outline"
                  size={16}
                  color={colors[theme].text}
                />
                <Text
                  style={{
                    color: colors[theme].text,
                    fontSize: 12,
                    marginLeft: 2
                  }}
                >
                  {dict.take_a_photo}
                </Text>
              </TouchableOpacity>
            </View>
                )*/}
          {/* {o.objectType === 'Audio' && o.objectBlobReference && (
            <MiniAudioPlayer audio={o.objectBlobReference} />
          )} */}
        </View>
      </View>
    </View>
  );
}
